$(document).ready(function () {
    if (window.location.href === 'https://stage.dearfoams.com/on/demandware.store/Sites-dearfoams-Site' || window.location.href === 'https://www.dearfoams.com/' || window.location.href === 'https://stage.baggallini.com/on/demandware.store/Sites-dearfoams-Site' || window.location.href === 'https://www.baggallini.com/') {
        $('.homepage-hide-js').hide();
    }
});
